import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { message, Select, Spin, Table } from "antd";
import { FaDownload } from "react-icons/fa";
import { BiPlayCircle } from "react-icons/bi";
import { PiExportBold } from "react-icons/pi";

import "./style.scss"
import uris from "../../../config/uris";
import Breadcrumbs from "../../../assets/component/breadcrumbs";
import { antIcon } from "../../custom-playbook/manage-playbook";
import { InitiateSync, initiateSyncReset } from "../../../store/slices/gemini/file-sync";
import { setFilterValueNavigationState } from "../../../store/slices/gemini/filter-value";
import { entityList, GetEntityLevelData, getEntityLevelDataReset } from "../../../store/slices/gemini/get-entities";
import { ExportEntitiesAction, exportEntitiesActionReset } from "../../../store/slices/gemini/export-entities";
import { DownloadMetaJson, downloadMetaJsonReset } from "../../../store/slices/gemini/download-meta-json";

const menuData = {
    title: 'Entity Review',
    parentMenu: {
        name: 'Review',
        link: uris?.entityList,
    },
    subMenu: {
        name: 'Entity Review',
        link: uris?.entityList,
    },
}

const tableHeaderData = [
    {
        title: 'Entity Name',
        dataIndex: 'entityName',
        key: 'entityName',
        fixed: 'left',
        width: 200,
        sorter: (a, b) => (a?.entityNameRaw).localeCompare(b?.entityNameRaw),
        render: (_, record) => record?.entityName
    },
    {
        title: 'Review Status',
        dataIndex: 'reviewStatus',
        key: 'reviewStatus',
        width: 120,
        sorter: (a, b) => (a?.reviewStatus).localeCompare(b?.reviewStatus),
    },
    {
        title: 'Assessment Type',
        dataIndex: 'assessmentType',
        key: 'assessmentType',
        width: 120,
        sorter: (a, b) => a.assessmentType.localeCompare(b.assessmentType),
    },
    {
        title: 'Total Documents',
        dataIndex: 'totalDocuments',
        key: 'totalDocuments',
        width: 120,
        sorter: { compare: (a, b) => a.totalDocuments - b.totalDocuments, multiple: 3 },
    },
    {
        title: 'Total Reviewed',
        dataIndex: 'totalReviewed',
        key: 'totalReviewed',
        width: 120,
        sorter: { compare: (a, b) => a.totalReviewed - b.totalReviewed, multiple: 3 },
    },
    {
        title: 'Total Files',
        dataIndex: 'filesCount',
        key: 'filesCount',
        width: 120,
        sorter: { compare: (a, b) => a.filesCount - b.filesCount, multiple: 3 },
    },
    {
        title: 'Total Webpages',
        dataIndex: 'totalWebpages',
        key: 'totalWebpages',
        width: 120,
        sorter: { compare: (a, b) => a.totalWebpages - b.totalWebpages, multiple: 3 },
    },
    {
        title: 'Files Synced',
        dataIndex: 'filesSynced',
        key: 'filesSynced',
        width: 120,
        sorter: { compare: (a, b) => a.filesSynced - b.filesSynced, multiple: 3 },
    },
    {
        title: 'File Upload Success',
        dataIndex: 'fileSuccessCount',
        key: 'fileSuccessCount',
        width: 120,
        sorter: { compare: (a, b) => a.fileSuccessCount - b.fileSuccessCount, multiple: 3 },
    },
    {
        title: 'File Upload Failed',
        dataIndex: 'fileFailedCount',
        key: 'fileFailedCount',
        width: 120,
        sorter: { compare: (a, b) => a.fileFailedCount - b.fileFailedCount, multiple: 3 },
    },
    {
        title: 'Non-Convertible Files',
        dataIndex: 'nonConvertibleFiles',
        key: 'nonConvertibleFiles',
        width: 120,
        sorter: { compare: (a, b) => a.nonConvertibleFiles - b.nonConvertibleFiles, multiple: 3 },
    },
    {
        title: 'Files Reviewed',
        dataIndex: 'filesReviewedCount',
        key: 'filesReviewedCount',
        width: 120,
        sorter: { compare: (a, b) => a.filesReviewedCount - b.filesReviewedCount, multiple: 3 },
    },
    {
        title: 'Files Pending Review',
        dataIndex: 'filesPendingCount',
        key: 'filesPendingCount',
        width: 120,
        sorter: { compare: (a, b) => a.filesPendingCount - b.filesPendingCount, multiple: 3 },
    },
    {
        title: 'Entity Docs Accepted',
        dataIndex: 'fileEntityAcceptedCount',
        key: 'fileEntityAcceptedCount',
        width: 120,
        sorter: { compare: (a, b) => a.fileEntityAcceptedCount - b.fileEntityAcceptedCount, multiple: 3 },
    },
    {
        title: 'Entity Docs Pending',
        dataIndex: 'fileEntityPendingCount',
        key: 'fileEntityPendingCount',
        width: 120,
        sorter: { compare: (a, b) => a.fileEntityPendingCount - b.fileEntityPendingCount, multiple: 3 },
    },
    {
        title: 'Entity Docs Rejected',
        dataIndex: 'fileEntityRejectedCount',
        key: 'fileEntityRejectedCount',
        width: 120,
        sorter: { compare: (a, b) => a.fileEntityRejectedCount - b.fileEntityRejectedCount, multiple: 3 },
    },
    {
        title: 'FY Docs Accepted',
        dataIndex: 'fileFyAcceptedCount',
        key: 'fileFyAcceptedCount',
        width: 120,
        sorter: { compare: (a, b) => a.fileFyAcceptedCount - b.fileFyAcceptedCount, multiple: 3 },
    },
    {
        title: 'FY Docs Rejected',
        dataIndex: 'fileFyRejectedCount',
        key: 'fileFyRejectedCount',
        width: 120,
        sorter: { compare: (a, b) => a.fileFyRejectedCount - b.fileFyRejectedCount, multiple: 3 },
    },
    {
        title: 'Webpages Accepted (Entity)',
        dataIndex: 'webpageEntityAcceptedCount',
        key: 'webpageEntityAcceptedCount',
        width: 120,
        sorter: { compare: (a, b) => a.webpageEntityAcceptedCount - b.webpageEntityAcceptedCount, multiple: 3 },
    },
    {
        title: 'Webpages Rejected (Entity)',
        dataIndex: 'webpageEntityRejectedCount',
        key: 'webpageEntityRejectedCount',
        width: 120,
        sorter: { compare: (a, b) => a.webpageEntityRejectedCount - b.webpageEntityRejectedCount, multiple: 3 },
    },
    {
        title: 'Webpages Accepted (FY)',
        dataIndex: 'webpageFyAcceptedCount',
        key: 'webpageFyAcceptedCount',
        width: 120,
        sorter: { compare: (a, b) => a.webpageFyAcceptedCount - b.webpageFyAcceptedCount, multiple: 3 },
    },
    {
        title: 'Webpages Pending (FY)',
        dataIndex: 'webpageFyPendingCount',
        key: 'webpageFyPendingCount',
        width: 120,
        sorter: { compare: (a, b) => a.webpageFyPendingCount - b.webpageFyPendingCount, multiple: 3 },
    },
    {
        title: 'Webpages Rejected (FY)',
        dataIndex: 'webpageFyRejectedCount',
        key: 'webpageFyRejectedCount',
        width: 120,
        sorter: { compare: (a, b) => a.webpageFyRejectedCount - b.webpageFyRejectedCount, multiple: 3 },
    },
    {
        title: 'Webpages Failed',
        dataIndex: 'failedWebpageCount',
        key: 'failedWebpageCount',
        width: 120,
        sorter: { compare: (a, b) => a.failedWebpageCount - b.failedWebpageCount, multiple: 3 },
    },
    {
        title: 'Nested Webpage Docs',
        dataIndex: 'webpageNestedDocCount',
        key: 'webpageNestedDocCount',
        width: 120,
        sorter: { compare: (a, b) => a.webpageNestedDocCount - b.webpageNestedDocCount, multiple: 3 },
    },
    {
        title: 'Webpages Reviewed',
        dataIndex: 'webpageReviewedCount',
        key: 'webpageReviewedCount',
        width: 120,
        sorter: { compare: (a, b) => a.webpageReviewedCount - b.webpageReviewedCount, multiple: 3 },
    },
    {
        title: 'Webpages Review Pending',
        dataIndex: 'webpageReviewPendingCount',
        key: 'webpageReviewPendingCount',
        width: 120,
        sorter: { compare: (a, b) => a.webpageReviewPendingCount - b.webpageReviewPendingCount, multiple: 3 },
    },
    {
        title: 'Webpage Upload Success',
        dataIndex: 'webpageSuccessCount',
        key: 'webpageSuccessCount',
        width: 120,
        sorter: { compare: (a, b) => a.webpageSuccessCount - b.webpageSuccessCount, multiple: 3 },
    },
    {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        width: 50,
        fixed: 'right'
    },
];


const EntityList = ({ setHideSidebar }) => {

    const [showFilters, setShowFilters] = useState(true)
    const [selectedEntity, setSelectedEntity] = useState([])
    const [selectedReviewStatus, setSelectedReviewStatus] = useState(null)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(200)
    const [formattedTableData, setFormattedTableData] = useState({
        dataSource: []
        // , columns: []
    })
    const [shouldReload, setShouldReload] = useState(false);
    const [selectedAssessmentType, setSelectedAssessmentType] = useState("Asset")
    const [appliedFilters, setAppliedFilters] = useState({
        entity_Ids: [],
        reviewStatus: "",
        assessmentType: [selectedAssessmentType],
    });

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { data: entityDropdownData, isLoading: entityLoading } = useSelector((state) => state?.entityList)
    const { data: entityListData, isLoading: entityListLoading } = useSelector((state) => state?.getEntityLevelData) || {}
    const { isLoading: exportLoading, error: exportError } = useSelector((state) => state?.exportEntitiesData) || {};
    const { data: initiateSyncData, isLoading: initiateSyncLoading, error: initiateSyncError, success: initiateSyncSuccess } = useSelector((state) => state?.initiateSync) || {}
    const { data: downloadMetaJsonData, isLoading: downloadMetaJsonLoading, error: downloadMetaJsonError } = useSelector((state) => state?.downloadMetaJson) || {}

    const fileReviewOptions = [
        { label: "Pending", value: "Pending" },
        { label: "Completed (Ready to Initiate)", value: "Completed" },
        { label: "Initiated", value: "Initiated" },
    ]

    const assessmentTypeOptions = [
        { label: "Asset", value: "Asset" },
        { label: "Fund", value: "Fund" },
        { label: "Real-Estate", value: "GRESB Real Estate" }
    ]

    const triggerReload = () => setShouldReload(prev => !prev);

    const handleEntityDetailsRoute = (entity) => {
        dispatch(setFilterValueNavigationState({
            entity: [{ label: entity?.entityName, value: entity?.entityObjectId }],
        }));
        navigate("/review-entities");
    }

    const handleDownloadMetaJson = (entityId) => {
        if (downloadMetaJsonLoading) return;
        if (entityId) {
            dispatch(DownloadMetaJson({ entityId: entityId }));
        }
    }

    const handleAssessmentTypeChange = (e) => {
        setSelectedAssessmentType(e)
    }

    const tableStructuredData = (tableData) => {
        const formattedData = tableData?.map((entity) => {
            return {
                key: entity?.entityObjectId,
                entityName: (
                    <div className="entity-name" onClick={() => handleEntityDetailsRoute(entity)}>{entity?.entityName}</div>
                ),
                entityNameRaw: entity?.entityName || "",
                reviewStatus: entity?.entityReviewStatus || "",
                assessmentType: (entity?.assessment_type?.length > 0 && entity?.assessment_type?.join(', ')) || "",
                batchStatus: entity?.initialtionStatus || "",
                totalDocuments: entity?.totalDocsCount || "",
                totalReviewed: entity?.totalReviewedCount || "",
                filesCount: entity?.totalFileCount || "",
                filesSynced: entity?.totalSyncedFiles || "",
                fileSuccessCount: entity?.fileSuccessCount || "",
                fileFailedCount: entity?.fileFailedCount || "",
                nonConvertibleFiles: entity?.nonConvertibleFileCount || "",
                filesReviewedCount: entity?.fileReviewedCount || "",
                filesPendingCount: entity?.fileReviewPendingCount || "",
                fileEntityAcceptedCount: entity?.entityDocAcceptedCount || "",
                fileEntityPendingCount: entity?.entityDocPendingCount || "",
                fileEntityRejectedCount: entity?.entityDocRejectedCount || "",
                fileFyAcceptedCount: entity?.fyDocAcceptedCount || "",
                fileFyRejectedCount: entity?.fyDocRejectedCount || "",
                webpageEntityAcceptedCount: entity?.entityWebpageAcceptedCount || "",
                webpageEntityRejectedCount: entity?.entityWebpageRejectedCount || "",
                webpageFyAcceptedCount: entity?.fyWebpageAcceptedCount || "",
                webpageFyPendingCount: entity?.fyWebpagePendingCount || "",
                webpageFyRejectedCount: entity?.fyWebpageRejectedCount || "",
                totalWebpages: entity?.totalWebpageCount || "",
                failedWebpageCount: entity?.webpageFailureCount || "",
                webpageNestedDocCount: entity?.webpageNestedDocsCount || "",
                webpageReviewedCount: entity?.webpageReviewedCount || "",
                webpageReviewPendingCount: entity?.webpageReviewPendingCount || "",
                webpageSuccessCount: entity?.webpageSuccessCount || "",
                actions: (
                    <div className="action-icon" onClick={() => handleDownloadMetaJson(entity?.entityObjectId)}><FaDownload /></div>
                )
            }
        })
        return formattedData;
    }

    const handleEntityChange = (e) => {
        setSelectedEntity(e)
    }

    const handleInitiate = () => {
        if (selectedRowKeys?.length === 0) return;
        const payload = {
            "entity_Ids": selectedRowKeys
        }
        dispatch(InitiateSync(payload))
    }

    const handleApplyFilters = () => {
        dispatch(getEntityLevelDataReset());
        if ((selectedEntity?.length === 0 && !selectedReviewStatus && !selectedAssessmentType) || entityListLoading) return;
        const filters = {
            entity_Ids: selectedEntity ? selectedEntity : [],
            reviewStatus: selectedReviewStatus || "",
            assessmentType: selectedAssessmentType ? [selectedAssessmentType] : [],
        };
        setSelectedRowKeys([]);
        setAppliedFilters(filters);
        setPage(1);
    }

    const handleExportEntities = () => {
        dispatch(exportEntitiesActionReset())
        const payload = {
            page,
            limit,
            entity_Ids: selectedEntity ? selectedEntity : [],
            reviewStatus: selectedReviewStatus || "",
            assessmentType: selectedAssessmentType ? [selectedAssessmentType] : [],
            isExcelExport: true
        }
        dispatch(ExportEntitiesAction(payload))
    }

    const handleResetFilters = () => {
        setSelectedRowKeys([]);
        setSelectedEntity([]);
        setSelectedReviewStatus(null);
        setSelectedAssessmentType(null);
        setAppliedFilters({
            entity_Ids: [],
            reviewStatus: "",
            assessmentType: [],
        })
        setPage(1);
    }

    const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {
        setSelectedRowKeys(newSelectedRowKeys)
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
            disabled: record.reviewStatus === "Pending" || record.reviewStatus === "Initiated",
        }),
    }

    const handleReviewStatusChange = (e) => {
        setSelectedReviewStatus(e)
    }

    const handleTableChange = (pagination) => {
        setPage(pagination.current);
        setLimit(pagination.pageSize);
    };

    useEffect(() => {
        setHideSidebar(true)
        dispatch(entityList())
    }, [])

    useEffect(() => {
        const payload = {
            page,
            limit,
            ...appliedFilters
        }
        dispatch(GetEntityLevelData(payload))
    }, [page, limit, appliedFilters, shouldReload])

    useEffect(() => {
        const formattedData = entityListData?.responseData
            ? tableStructuredData(entityListData?.responseData)
            : [];

        setFormattedTableData({
            dataSource: formattedData,
            // columns: tableHeaderData
        });
    }, [entityListData?.responseData]);

    useEffect(() => {
        if (initiateSyncError) {
            message.error(initiateSyncError?.message)
            dispatch(initiateSyncReset())
        }
        if (initiateSyncSuccess) {
            message.success(initiateSyncData?.message)
            triggerReload();
            dispatch(initiateSyncReset())
        }
    }, [initiateSyncError, initiateSyncSuccess])

    useEffect(() => {
        if (exportError) {
            message.error(exportError?.message)
            dispatch(exportEntitiesActionReset())
        }
        if (downloadMetaJsonError) {
            message.error(downloadMetaJsonError?.message)
            dispatch(downloadMetaJsonReset())
        }
    }, [exportError, downloadMetaJsonError])

    useEffect(() => {
        if (downloadMetaJsonData) {
            const link = document?.createElement('a');
            link.href = downloadMetaJsonData?.url;
            link.download = '';
            link.setAttribute('target', '_blank');
            document?.body?.appendChild(link);
            link.click();
            document?.body?.removeChild(link);
            dispatch(downloadMetaJsonReset())
        }
    }, [downloadMetaJsonData])

    return (
        <div className="entity-list-main">
            <Breadcrumbs breadcrumbDetails={menuData} />
            <div className="entity-list-filters">
                {
                    showFilters && (
                        <div className="filters-section">
                            <div className="entity-list-screen-filters-section">
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        Assessment Type
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            className="filter-select"
                                            options={assessmentTypeOptions}
                                            onChange={handleAssessmentTypeChange}
                                            value={selectedAssessmentType}
                                            placeholder="Select Type"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                        />
                                    </div>
                                </div>
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        Entity
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            mode="multiple"
                                            maxTagCount={1}
                                            className="filter-select"
                                            options={entityDropdownData?.responseData}
                                            onChange={handleEntityChange}
                                            value={selectedEntity}
                                            placeholder="Select Entity"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                            notFoundContent={entityLoading ? <div className="dropdown-loading"><Spin size="small" /></div> : <div className="dropdown-loading">No Data</div>}
                                        />
                                    </div>
                                </div>
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        Review Status
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            className="filter-select"
                                            options={fileReviewOptions}
                                            onChange={handleReviewStatusChange}
                                            value={selectedReviewStatus}
                                            placeholder="Select Status"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                        />
                                    </div>
                                </div>
                                <div className="filter-buttons-wrapper">
                                    <div className={`button-wrapper ${((selectedEntity?.length === 0 && !selectedReviewStatus && !selectedAssessmentType) || entityListLoading) ? "disabled" : ""}`} onClick={() => handleApplyFilters()}>Apply</div>
                                    <div className="button-wrapper" onClick={() => handleResetFilters()}>Reset</div>
                                </div>
                                <div className="filter-buttons-section content-buttons-left">
                                    <div
                                        className="button-wrapper export-master-questions"
                                        onClick={handleExportEntities}
                                    >
                                        {exportLoading ? <Spin className="export" indicator={antIcon} /> : <PiExportBold />}
                                        Export
                                    </div>
                                    <div className={`button-wrapper ${(initiateSyncLoading || selectedRowKeys?.length === 0) ? "disabled" : ""}`} onClick={handleInitiate}>
                                        {initiateSyncLoading ? <Spin indicator={antIcon} /> : <BiPlayCircle />}
                                        Initiate
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
            <div className="entity-list-table-section">
                <Table
                    loading={entityListLoading}
                    columns={tableHeaderData}
                    dataSource={formattedTableData?.dataSource}
                    pagination={{
                        current: page,
                        pageSize: limit,
                        total: entityListData?.totalCount,
                        showTotal: (total) => `Total : ${total} records`,
                        pageSizeOptions: ["10", "20", "50", "100", "200", "500"],
                        showSizeChanger: true,
                    }}
                    scroll={{ x: 3000, y: window.innerHeight - 330 }}
                    onChange={handleTableChange}
                    rowSelection={rowSelection}
                />
            </div>
        </div>
    )
}

export default EntityList;